import { queryOptions } from '@tanstack/react-query'
import { getWork } from 'Work/api/WorkApi'

import { RequestStaleTime } from 'Common/utils/helpers/HelperQuery'

export const workQueries = {
    all: () => ['works'],
    details: () => [...workQueries.all(), 'detail'],
    detail: (id: number) =>
        queryOptions({
            queryKey: [...workQueries.details(), id],
            queryFn: () => getWork(id),
            staleTime: RequestStaleTime.default,
        }),
}
